// import Carousel from './components/Carousel';
// import aione from '@/assets/aione.png';
// import leftgame from '@/assets/leftgame.png';
// import aibottom from '@/assets/aibottom.png';
// import aiiphonebtn from '@/assets/aiiphonebtn.png';
// import aiiphoneone from '@/assets/aiiphoneone.png';
import aitext from '@/assets/ai/aitext.png';
import ailine from '@/assets/ai/ailine.png';
import aiayabj from '@/assets/ai/aiayabj.png';
import aibluearrow from '@/assets/ai/aibluearrow.png';
import ailogo from '@/assets/ai/ailogo.png';
import aiUnion from '@/assets/ai/aiUnion.png';
import aicolorbj from '@/assets/ai/aicolorbj.png';
import aibottom from '@/assets/ai/aibottom.png';
import aiorginarrow from '@/assets/ai/aiorginarrow.png';
import indexvideo from '@/assets/ai/video/indexvideo.mp4';
import aimiddlevideo from '@/assets/ai/video/aimiddlevideo.mp4';
import aibottomvideo from '@/assets/ai/video/aibottom.mp4';
import aigamelogo1 from '@/assets/ai/gamelogo/aigamelogo1.png';
import aigamelogo2 from '@/assets/ai/gamelogo/aigamelogo2.png';
import aigamelogo3 from '@/assets/ai/gamelogo/aigamelogo3.png';
import aigamelogo4 from '@/assets/ai/gamelogo/aigamelogo4.png';
import aigamelogo5 from '@/assets/ai/gamelogo/aigamelogo5.png';
import aigamelogo6 from '@/assets/ai/gamelogo/aigamelogo6.png';
import aya from '@/assets/ai/aya.png';
import Card from './components/card';
import AppCard from './components/appcard';
import ChatgptComponent from "@/components/Chatgpt/Chatgpt.jsx";
function Aidemo() {
    return (
        <div className='overflow-hidden'>
            {/* <div className="w-full lg:h-[700px] h-[200px] flex items-center justify-center relative">
                <img
                    src={leftgame}
                    alt="Left Icon"
                    className="absolute left-[-7rem] top-[12rem] transform -translate-y-1/2 w-72 h-72 sm:block hidden"
                />
                <img src={aione} className='w-[1100px]  absolute lg:block hidden' alt="" />
                <img src={aiiphoneone} className='w-full absolute lg:hidden block' alt="" />
                <p className="lg:text-[80px] text-[30px]  text-white z-[1] lg:mt-0 mt-[40%]">AI in Play, Play with <span className="lg:text-9xl text-[48px] text-[#2631fb]">AI</span> </p>
            </div>
            <div className="w-full lg:h-[900px] h-[900px] flex items-center justify-center">
                <Carousel />
            </div>
            <div className="w-full relative">
                <img src={aibottom} alt="" className='w-full lg:block hidden' />
                <img src={aiiphonebtn} alt="" className='w-full lg:hidden block' />
                <div className='absolute top-[65%] left-[10%]  w-[601px] lg:block hidden'>
                    <p className='text-[40px] text-white'>AI Agent for Gamification</p>
                    <p className='mt-2 text-xl text-[#9da7f7]'>Autonomous gameplay, personalized strategies.
                        ERC6551-driven AI Agents adapt to your playstyle, automate
                        tasks, and create new in-game opportunities.</p>
                </div>
                <div className='lg:hidden block '>
                    <div className='flex items-center justify-center flex-col'>
                        <p className='text-white text-xl'>AI Agent for Gamification</p>
                        <p className='mt-2 text-sm	 w-[309px] text-center mb-3 text-[#999999]'>Autonomous gameplay, personalized strategies.
                            ERC6551-driven AI Agents adapt to your playstyle, automate
                            tasks, and create new in-game opportunities.</p>
                    </div>

                </div>
            </div> */}
            {/* pc */}
            <div className='sm:block hidden'>
                <div className="w-screen h-[600px]  relative overflow-hidden">
                    <video className="absolute top-0 left-0 w-screen h-full object-cover" loop autoPlay muted>
                        <source src={indexvideo} type="video/mp4" />
                    </video>
                    <img src={ailogo} className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[1] w-auto h-[500px]' alt="" />
                    <img
                        src={aitext}
                        alt="A.I. Text Bottom"
                        className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-[2] w-auto h-[115px]"
                    />
                </div>


                <div className="w-full flex justify-center flex-col items-center relative mt-3">
                    <p className='text-6xl font-semibold text-white mt-24 flex items-center mr-10 z-[2]'>
                        <img src={aibluearrow} alt="" className='w-[38px] h-[38px]' />
                        Aya
                    </p>
                    <img src={ailine} alt="" className='w-auto h-[41px] z-[2]' />
                    <img src={aiayabj} alt="" className='absolute top-0 w-auto h-[164px] z-[1]' />
                    <img src={aiUnion} alt="" className='absolute top-0 w-auto h-[315px] z-[1]' />

                    <div className="relative w-full mt-3">
                        <img src={aya} alt="" className="w-full h-auto mb-[-23px]" />

                        <p className="absolute top-2 left-0 right-0 m-auto w-[1019px] text-xl text-[#9F9F9F] text-center z-[2] mb-4">
                            Aya is more than just an AI tool&mdash;she&rsquo;s your partner, collaborator, and creator on your gaming journey. She embodies the future of gaming: intelligent, personalized, and boundless.
                        </p>
                    </div>

                    <div className="h-[378px] mb-9">
                        <Card />
                    </div>
                </div>



                <div className='w-full relative'>
                    <img src={aicolorbj} alt="" />
                    <div className='w-[1328px] h-[527px] bg-black absolute top-[58%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-lg border-[2px] border-transparent' style={{
                        border: '2px solid transparent',
                        borderRadius: '12px',
                        background: 'linear-gradient(90deg, #8c8bff 0%, #ffa693 14%, #efff8f 31%, #96ff85 49%, #8afff8 67%, #91a9ff 84%, #ff77b8 92%)',
                        backgroundClip: 'border-box'
                    }}>
                        <div className='w-full h-full relative rounded-lg overflow-hidden'>
                            <video className="absolute top-0 left-0 w-screen h-full object-cover" loop autoPlay muted>
                                <source src={aimiddlevideo} type="video/mp4" />
                            </video>
                            <div className='p-12 z-[1] absolute'>
                                <p className='text-6xl text-white font-semibold flex items-center'>
                                    <img src={aiorginarrow} alt="" className='w-[38px] h-[38px]' />
                                    <span className='ml-6'>AIGC for Co-Creation</span>
                                </p>
                                <p className='w-[723px] text-base text-[#9F9F9F] mt-6 ml-16'>
                                    Create, own, and play with next-gen game assets.
                                    Powered by BP-1 and BP-3D-1 models, generate game assets, mint them into NFTs, and package them into playable resources with the N2G protocol.
                                </p>
                            </div>
                        </div>
                    </div>


                </div>

                <div className='w-full  flex items-center justify-center'>
                    <div className='w-[1316px] h-[242px]  flex justify-between'>
                        <img src={aigamelogo1} alt="" className='w-[242px] h-[242px]' />
                        <img src={aigamelogo2} alt="" className='w-[242px] h-[242px]' />
                        <img src={aigamelogo3} alt="" className='w-[242px] h-[242px]' />
                        <img src={aigamelogo4} alt="" className='w-[242px] h-[242px]' />
                        <img src={aigamelogo5} alt="" className='w-[242px] h-[242px]' />
                    </div>
                </div>


                <div className='w-full  flex items-center justify-center mt-8 '>
                    <div className='w-[1316px] h-[580px]  flex items-center justify-center relative'>
                        <video className="absolute top-0 left-0 w-screen h-full object-cover z-0" loop autoPlay muted>
                            <source src={aibottomvideo} type="video/mp4" />
                        </video>
                        <div className='relative z-10'>
                            <p className='text-6xl text-white font-semibold flex justify-center mb-3'>AI Agent for Gamification</p>
                            <img src={aibottom} alt="" className='w-[809.64px]' />
                            <p className='w-[932px] text-base text-[#9F9F9F] mt-3 text-center'>Autonomous gameplay, personalized strategies.</p>
                            <p className='w-[932px] text-base text-[#9F9F9F] mt-3 text-center'>ERC6551-driven AI Agents adapt to your playstyle, automate tasks, and create new in-game opportunities.</p>
                        </div>
                    </div>
                </div>
                <ChatgptComponent greetingMessage="Let’s co-create — your ideas, my AI magic." />
            </div>


            {/* app */}
            <div className='sm:hidden block'>
                <div className="w-screen h-72  relative overflow-hidden">
                    <video className="absolute top-0 left-0 w-screen h-full object-cover" loop
                        autoPlay
                        muted
                        playsInline
                        onClick={(e) => e.preventDefault()}>
                        <source src={indexvideo} type="video/mp4" />
                    </video>
                    <img src={ailogo} className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[1] w-auto h-36' alt="" />
                    <img
                        src={aitext}
                        alt="A.I. Text Bottom"
                        className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-[2] w-auto h-8"
                    />
                </div>

                <div className="w-full   flex justify-center flex-col items-center relative mt-3">
                    <p className='text-3xl mt-3 font-semibold text-white flex items-center mr-10 z-[2]'>
                        <img src={aibluearrow} alt="" className='w-8 h-8' />
                        Aya
                    </p>
                    <img src={ailine} alt="" className='w-auto h-[14px]  z-[2]' />
                    <img src={aiayabj} alt="" className='absolute top-0  w-auto h-[42px] z-[1]' />
                    <img src={aiUnion} alt="" className='absolute top-0  w-auto h-[315px] z-[1]' />
                    <p className='w-80 h-[44px] text-base text-[#9F9F9F]'>
                        Aya is more than just an AI tool&mdash;she&rsquo;s your partner, collaborator, and creator on your gaming journey. She embodies the future of gaming: intelligent, personalized, and boundless.
                    </p>

                    <div className="w-full max-w-96 px-3 mt-28 mb-9 mx-auto">
                        <AppCard />
                    </div>


                </div>

                <div className='w-screen h-[267px] px-4 relative  p-3'>
                    <img src={aicolorbj} alt="" className='absolute top-[-8vw] left-0' />
                    <div className=' h-full bg-black rounded-lg border-[2px] border-transparent' style={{
                        border: '2px solid transparent',
                        borderRadius: '12px',
                        background: 'linear-gradient(90deg, #8c8bff 0%, #ffa693 14%, #efff8f 31%, #96ff85 49%, #8afff8 67%, #91a9ff 84%, #ff77b8 92%)',
                        backgroundClip: 'border-box'
                    }}>
                        <div className='w-full h-full relative rounded-lg overflow-hidden'>
                            <video className="absolute top-0 left-0 w-screen h-full object-cover" loop
                                autoPlay
                                muted
                                playsInline
                                onClick={(e) => e.preventDefault()}>
                                <source src={aimiddlevideo} type="video/mp4" />
                            </video>
                            <div className='p-2 z-[1] absolute'>
                                <p className='text-lg text-white font-semibold flex items-center mt-3'>
                                    <img src={aiorginarrow} alt="" className='w-[20px] h-[20px]' />
                                    <span className='ml-2'>AIGC for Co-Creation</span>
                                </p>
                                <p className='text-base text-[#9F9F9F] mt-3'>
                                    Create, own, and play with next-gen game assets.
                                    Powered by BP-1 and BP-3D-1 models, generate game assets, mint them into NFTs, and package them into playable resources with the N2G protocol.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="w-full flex items-center justify-center px-4 mb-2">
                    <div className="w-full max-w-[960px] h-auto flex flex-wrap justify-between gap-4">
                        <div className="w-[30%] h-auto flex justify-center">
                            <img src={aigamelogo1} alt="" className="w-full h-auto object-contain" />
                        </div>
                        <div className="w-[30%] h-auto flex justify-center">
                            <img src={aigamelogo2} alt="" className="w-full h-auto object-contain" />
                        </div>
                        <div className="w-[30%] h-auto flex justify-center">
                            <img src={aigamelogo3} alt="" className="w-full h-auto object-contain" />
                        </div>
                        <div className="w-[30%] h-auto flex justify-center">
                            <img src={aigamelogo4} alt="" className="w-full h-auto object-contain" />
                        </div>
                        <div className="w-[30%] h-auto flex justify-center">
                            <img src={aigamelogo5} alt="" className="w-full h-auto object-contain" />
                        </div>
                        <div className="w-[30%] h-auto flex justify-center">
                            <img src={aigamelogo6} alt="" className="w-full h-auto object-contain" />
                        </div>
                    </div>
                </div>

                <div className='w-full  flex items-center justify-center mt-8 '>
                    <div className='w-full h-44  flex items-center justify-center relative'>
                        <video
                            className="absolute top-0 left-0 w-screen h-full object-cover z-0"
                            loop
                            autoPlay
                            muted
                            playsInline
                            onClick={(e) => e.preventDefault()}
                        >
                            <source src={aibottomvideo} type="video/mp4" />
                        </video>

                        <div className='relative z-10 flex items-center justify-center flex-col'>
                            <p className='text-lg text-white font-semibold flex justify-center mb-3'>AI Agent for Gamification</p>
                            <img src={aibottom} alt="" className='w-[359px]' />
                            <div className='w-80 text-base text-[#9F9F9F] mt-3 text-center'>
                                <p>Autonomous gameplay, personalized strategies.
                                    ERC6551-driven AI Agents adapt to your playstyle, automate tasks, and create new in-game opportunities.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <ChatgptComponent greetingMessage="Let’s co-create — your ideas, my AI magic." />

            </div>
        </div >

    )
}

export default Aidemo;
